module.exports = __webpack_public_path__ + "static/media/15.8fe6f5e1.jpg";